import type { CreateTrialAccountCommand } from "@/domain/model/Registration";
import type { CreateTrialAccountForm } from "./CreateTrialAccountSchema";

export function toCreateTrialAccountCommand(
  form: CreateTrialAccountForm,
): CreateTrialAccountCommand {
  return {
    email: form.email,
    password: form.password,
    ownerName: form.ownerName,
    accountName: form.accountName,
    seats: form.seats,
  };
}

export function toCreateTrialAccountErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    try {
      const problem: unknown = JSON.parse(error.message);
      if (
        typeof problem === "object" &&
        problem !== null &&
        "title" in problem
      ) {
        if (problem.title === "Email already in use") {
          return "Diese E-Mail-Adresse wird bereits verwendet. Bitte melden Sie sich an oder verwenden Sie eine andere E-Mail-Adresse.";
        }
        if (problem.title === "Account name already in use") {
          return "Dieser Kontoname wird bereits verwendet. Bitte wählen Sie einen anderen Namen.";
        }
      }
    } catch {
      // Network errors and non-JSON responses use the same user-facing fallback.
    }
  }
  return "Das Testkonto konnte nicht erstellt werden. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut. Falls das Konto bereits erstellt wurde, können Sie sich anmelden.";
}
